<script>
  import { apiServer } from "../config.js";
  import { redirect } from "../pager";
  import Alert from "../components/Alert.svelte";
  import { fade } from "svelte/transition";
  import Load from "../components/Load.svelte";

  import AXHR from "../components/js/axhr.js";
  import { session } from "../components/js/store.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  $: if (settings) {
    if (settings.loggedin == true) {
      window.location.href = "./";
    }
  } else {
    settings = {
      url: apiServer,
      loggedin: false,
    };
  }
  let alert = [];
  let shake = "shake";
  let require;

  $: require = {
    token: "",
  };
  let number;
  $: number = {};

  let require_check;

  $: require_check = {
    token: "",
  };
  let number_check;
  $: number = {};

  let email;
  $: email = {};

  //#FORM Data Payload

  let errorForm = [];
  function validator() {
    errorForm = [];
    for (var k in require) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var n in number) {
      if (document.getElementById(n + "-warning")) {
        document.getElementById(n + "-warning").style.display = "none";
        document.getElementById(n + "-labelwarning").style = "";
        document.getElementById(n + "-warning").innerHTML = "";
      }
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }
    for (var e in email) {
      if (document.getElementById(e + "-warning")) {
        document.getElementById(e + "-warning").style.display = "none";
        document.getElementById(e + "-labelwarning").style = "";
        document.getElementById(e + "-warning").innerHTML = "";
      }
      if (
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email[e]
        )
      ) {
      } else {
        errorForm = [
          ...errorForm,
          { field: e, message: "Pastikan Email sudah tepat" },
        ];
        if (document.getElementById(e + "-warning")) {
          document.getElementById(e + "-warning").style.display =
            "inline-block";
          document.getElementById(e + "-warning").innerHTML =
            "Pastikan Email sudah tepat";
        }
        if (document.getElementById(e + "-labelwarning")) {
          document.getElementById(e + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  function validator_check() {
    errorForm = [];
    for (var k in require_check) {
      if (document.getElementById(k + "-labelwarning")) {
        document.getElementById(k + "-labelwarning").style = "";
      }
      if (document.getElementById(k + "-warning")) {
        document.getElementById(k + "-warning").style.display = "none";
        document.getElementById(k + "-warning").innerHTML = "";
      }
      if (
        require[k] !== undefined &&
        require[k] !== null &&
        require[k] !== "" &&
        require[k] !== false
      ) {
      } else {
        errorForm = [...errorForm, { field: k, message: "Mohon diisi" }];
        if (document.getElementById(k + "-warning")) {
          document.getElementById(k + "-warning").style.display =
            "inline-block";
          document.getElementById(k + "-warning").innerHTML = "Mohon diisi";
        }
        if (document.getElementById(k + "-labelwarning")) {
          document.getElementById(k + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    for (var n in number_check) {
      document.getElementById(n + "-warning").style.display = "none";
      document.getElementById(n + "-labelwarning").style = "";
      document.getElementById(n + "-warning").innerHTML = "";
      if (/^\+?(0|[1-9]\d*)$/.test(number[n])) {
      } else {
        errorForm = [
          ...errorForm,
          { field: n, message: "Pastikan Hanya Angka" },
        ];
        if (document.getElementById(n + "-warning")) {
          document.getElementById(n + "-warning").style.display =
            "inline-block";
          document.getElementById(n + "-warning").innerHTML =
            "Pastikan Hanya Angka";
        }
        if (document.getElementById(n + "-labelwarning")) {
          document.getElementById(n + "-labelwarning").style.color =
            "rgb(255, 102, 102)";
        }
      }
    }

    if (errorForm.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  let loading = false;
  let success;
  $: success = false;
  export let params;
  if (params) {
    require = {
      token: params.token,
    };
    handleSubmit();
  }
  async function handleSubmit(event) {
    loading = true;
    let valid;
    let payload;
    valid = validator();
    payload = {
      token: require.token,
    };
    if (valid) {
      shake = "";
      AXHR.post(apiServer + "/accounts/verify-email", payload)
        .then(function (response) {
          alert = [
            ...alert,
            {
              title: "Mikhub",
              message: response.data.message,
              color: "green",
            },
          ];
          success = true;
          loading = false;
        })
        .catch(function (error) {
          success = false;
          loading = false;

          shake = "shake";
          alert = [
            ...alert,
            {
              title: "Oops...",
              message: error.response.data.message,
              color: "yellow",
            },
          ];
        });
    } else {
      success = false;
      loading = false;
      shake = "shake";
    }
  }

  let step = 1;
</script>

<svelte:head>
  <title>Mikhub - Activate Account</title>
</svelte:head>
{#if alert.length > 0}
  <div class="fixed bottom-0 right-0 z-50 w-full px-2 mx-auto mb-10 lg:w-auto">
    {#each alert as a}
      <Alert color={a.color} title={a.title} message={a.message} />
    {/each}
  </div>
{/if}

<main
  transition:fade
  class="max-w-screen-xl px-2 pt-0 mx-auto mb-2 lg:pt-0 md:pt-16"
>
  {#if loading}
    <Load />
  {/if}
  <div class={shake}>
    <div class="w-full mx-auto mt-24 lg:mt-5 md:w-2/4 lg:w-2/5">
      <div class="flex justify-center font-bold">
        <img
          on:click={() => redirect("/")}
          src="./assets/logo/logo.svg"
          width="274"
          height="64"
          alt="logo"
          class="h-16 cursor-pointer"
        />
      </div>
      <h2 class="mb-4 text-center text-gray-700 text-1xl">
        <b>activate</b> your account
      </h2>

      {#if success === true}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl">Activation Success !</b>Now you
                can enter / login with the account email & password that you
                created
                <a
                  href="/login"
                  class="block px-5 py-2 my-5 text-white bg-gray-600 rounded"
                  >LOGIN</a
                >
              </p>
            </div>
          </div>
        </div>
      {:else}
        <div class="flex flex-wrap items-center w-full mx-auto my-5 lg:my-0 ">
          <div class="w-full mx-auto mb-2">
            <div class="block p-5 py-10 bg-white rounded-lg shadow-md group">
              <p class="text-center">
                <b class="block mb-5 text-xl">activate account</b>Enter the code
                that we sent to your email below
              </p>
              <form
                class="px-2"
                autocomplete="off"
                on:submit|preventDefault={handleSubmit}
              >
                <section class="mt-5">
                  <label for="token" class="relative block text-sm font-light">
                    <input
                      class="w-full rounded-lg form-input"
                      name="token"
                      id="token"
                      autocomplete="off"
                      type="text"
                      placeholder="Token Code"
                      bind:value={require.token}
                    />
                    <span
                      class="absolute top-0 block px-1 mx-3 -mt-3 text-sm font-light bg-white"
                      id="token-labelwarning"
                      >Token Code
                    </span>
                    <span
                      class="hidden px-2 mx-auto font-mono text-xs italic text-red-400 border border-red-300 rounded-full rounded-tl-none warning"
                      id="token-warning"
                    />
                  </label>
                </section>

                {#if loading}
                  <button
                    type="submit"
                    class="w-auto px-16 py-2 mt-5 text-gray-100 bg-gray-500 rounded-lg opacity-25 text-1xl active:bg-gray-500 focus:outline-none"
                    disabled="disabled"
                  >
                    PROCESS...
                  </button>
                {:else}
                  <button
                    type="submit"
                    class="w-auto px-16 py-2 mt-5 text-gray-100 bg-gray-700 rounded-lg text-1xl active:bg-gray-500 focus:outline-none"
                    on:click={handleSubmit}
                  >
                    ACTIVATE
                  </button>
                {/if}
              </form>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</main>
<div class="flex justify-center max-w-screen-xl px-5 py-1 mx-auto items-bottom">
  <div
    class="w-full mt-4 text-sm font-light text-center text-gray-700 sm:py-2 sm:mt-0"
  >
    <div>
      <span class="ml-1 text-gray-700">© 2021 Mikhub — RakIT Labs</span>
    </div>
  </div>
</div>
